import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { global } from 'app/utils/global';
import { Usuario } from 'app/domain/usuario';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public httpClient: HttpClient,
    public localStorageService: LocalStorageService, 
    public localStorage: LocalStorageService) {
    this.url = environment.URL_SICO + 'usuario/';
  }

  public getUsuario(): Usuario {
    let usuario: Usuario = this.localStorage.get(global.SESSION_ITEMS.USU_SESION);
    
    return usuario;
  }

  public getRol(): string{

    let usuario: Usuario = this.localStorage.get(global.SESSION_ITEMS.USU_SESION);

    return usuario.nombreRol;
  }

  public logisticaReversiva(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.LOGISTICA_REVERSIVA.CARRITO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }

  public garantia(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.GARANTIA.CARRITO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }

  public rotacion(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.ROTACION.CARRITO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }

  public recaudo(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.RECAUDO.CARRITO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }

  public menuDerecho(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.MENU_DERECHO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }

  public tomarPedido(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.PEDIDO.CARRITO);
    if(exist){
      return true;
    }else{
      return false;
    }
  }
  
  public cliente(): boolean{
    let exist = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
    if(exist !== null){
      return true;
    }else{
      return false;
    }
  }
}
